export default __webpack_public_path__ + "static/media/login-showpass.3c319987.svg";